import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="flex flex-col w-full" data-id="element-99">
      {/* Opening Hook */}
      <div className="bg-white py-16 px-4" data-id="element-100">
        <div className="max-w-3xl mx-auto" data-id="element-101">
          <p className="text-xl md:text-2xl font-heading italic text-text-dark leading-relaxed text-center border-l-4 border-gold pl-6 py-2" data-id="element-102">
            "Estás en el concesionario de autos o en la oficina de rentas. Has
            trabajado duro, tienes el dinero del depósito en la mano y hablas
            con honestidad. Pero el agente mira su pantalla, suspira y te dice
            las palabras que más duelen:{' '}
            <span className="font-bold text-navy" data-id="element-103">
              "Lo siento, no tienes historial, no calificas"
            </span>
            . No importa cuántos años lleves trabajando o qué tan responsable
            seas con tus gastos. En este país, si no tienes un número que te
            respalde, simplemente no existes para el sistema."
          </p>
        </div>
      </div>

      {/* The Problem */}
      <div className="bg-gray-light py-16 px-4" data-id="element-104">
        <div className="max-w-4xl mx-auto" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-10 text-center" data-id="element-106">
            Vivir "solo en efectivo" en Estados Unidos es una trampa silenciosa
          </h2>

          <div className="space-y-6 text-lg text-text-muted mb-10" data-id="element-107">
            <p className="flex items-start" data-id="element-108">
              <span className="text-gold mr-3 text-2xl leading-none" data-id="element-109">•</span>
              <span data-id="element-110">
                Te obliga a pagar depósitos de miles de dólares para abrir la
                luz o el gas.
              </span>
            </p>
            <p className="flex items-start" data-id="element-111">
              <span className="text-gold mr-3 text-2xl leading-none" data-id="element-112">•</span>
              <span data-id="element-113">
                A manejar autos viejos que se rompen cada mes porque no puedes
                financiar uno mejor.
              </span>
            </p>
            <p className="flex items-start" data-id="element-114">
              <span className="text-gold mr-3 text-2xl leading-none" data-id="element-115">•</span>
              <span data-id="element-116">
                A depender de que alguien más firme por ti como si fueras una
                niña.
              </span>
            </p>
            <p className="flex items-start" data-id="element-117">
              <span className="text-gold mr-3 text-2xl leading-none" data-id="element-118">•</span>
              <span data-id="element-119">
                A los 40 años o más, después de todo lo que has sacrificado por
                llegar aquí, no mereces que un vendedor te mire con lástima.
              </span>
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-xl shadow-md border-t-4 border-navy" data-id="element-120">
            <p className="text-xl font-bold text-navy text-center" data-id="element-121">
              El problema no es tu falta de dinero; es que nadie te ha enseñado
              las reglas de un juego que está diseñado para que te quedes fuera.
            </p>
          </div>
        </div>
      </div>

      {/* Failed Attempts */}
      <div className="bg-white py-16 px-4" data-id="element-122">
        <div className="max-w-4xl mx-auto" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-10 text-center" data-id="element-124">
            ¿Por qué lo que has intentado no ha funcionado?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-125">
            <div className="bg-gray-light p-6 rounded-lg flex items-start" data-id="element-126">
              <XCircleIcon className="text-red-500 w-8 h-8 flex-shrink-0 mr-4 mt-1" data-id="element-127" />
              <p className="text-text-dark" data-id="element-128">
                <strong data-id="element-129">Aplicaste a tarjetas de bancos grandes</strong> como
                Chase o Bank of America y te rechazaron de inmediato porque no
                "calentaste" tu perfil antes.
              </p>
            </div>

            <div className="bg-gray-light p-6 rounded-lg flex items-start" data-id="element-130">
              <XCircleIcon className="text-red-500 w-8 h-8 flex-shrink-0 mr-4 mt-1" data-id="element-131" />
              <p className="text-text-dark" data-id="element-132">
                <strong data-id="element-133">
                  Creíste que por no tener Seguro Social (SSN) no podías tener
                  crédito
                </strong>
                , ignorando que tu ITIN es una llave maestra si sabes usarla.
              </p>
            </div>

            <div className="bg-gray-light p-6 rounded-lg flex items-start" data-id="element-134">
              <XCircleIcon className="text-red-500 w-8 h-8 flex-shrink-0 mr-4 mt-1" data-id="element-135" />
              <p className="text-text-dark" data-id="element-136">
                <strong data-id="element-137">Confiaste en supuestos "reparadores"</strong> que te
                cobraron cientos de dólares por borrar manchas, cuando lo que tú
                necesitas es construir una base nueva.
              </p>
            </div>

            <div className="bg-gray-light p-6 rounded-lg flex items-start" data-id="element-138">
              <XCircleIcon className="text-red-500 w-8 h-8 flex-shrink-0 mr-4 mt-1" data-id="element-139" />
              <p className="text-text-dark" data-id="element-140">
                <strong data-id="element-141">
                  Pensaste que el tiempo solo arreglaría las cosas
                </strong>
                , pero el crédito no crece por "viejo", crece por actividad
                reportada.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}